export default __webpack_public_path__ + "static/media/visibilityIcon.b784841b.svg";